<script lang="ts" setup>
    import { ref, computed, onMounted } from "vue"
    import { isAdminDomain } from "~/logic"
    import { useEntrepriseStore } from "~/stores"

    const companyDetails = ref({})
    const isReady = ref(false)

    const backgroundImage = computed(
        () => companyDetails.value?.BACKGROUND || "/icons/espace.svg",
    )

    const backgroundStyle = computed(() => ({
        backgroundImage: `url(${backgroundImage.value})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "100vh",
        width: "100%",
        position: "fixed",
        top: "0",
        left: "0",
        zIndex: -1,
    }))

    const entrepriseStore = useEntrepriseStore()
    onMounted(async () => {
        if (!isAdminDomain) {
            companyDetails.value = await entrepriseStore.getCompanyFromDomain()
        }
        isReady.value = true
    })

    const logo = computed(() => companyDetails.value?.LOGO)
</script>

<template>
    <div v-if="isReady" class="main-wrapper">
        <div :style="backgroundStyle" class="full-screen-background"></div>
        <v-img v-if="logo" :src="logo" class="logo animated-fade-in mt-10" />
        <v-container>
            <router-view />
        </v-container>
        <v-bottom-navigation
            v-if="!isAdminDomain"
            fixed
            bg-color="transparent"
            grow
            horizontal
        >
            <v-btn :to="{ name: 'auth.login.manager' }">
                <span>Utilisateurs</span>
                <v-icon>mdi-briefcase</v-icon>
            </v-btn>

            <v-btn :to="{ name: 'auth.login.space' }">
                <span>Clients</span>
                <v-icon>mdi-account-multiple-outline</v-icon>
            </v-btn>
        </v-bottom-navigation>
    </div>
</template>

<style scoped>
    html, body {
    margin: 0;
    padding: 0;
    height: 100%;
}

.full-screen-background::before {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.6);
}

.logo {
    background-color: rgba(255, 255, 255, 0.6);
    border-radius: 4px;
    height: 150px;
    width: auto;
    margin: auto;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.animated-fade-in {
    animation: fadeIn 1s ease-out;
}

.main-wrapper {
    position: relative;
    z-index: 1;
    color: white;
}
</style>
